export default __webpack_public_path__ + "static/media/dad.79fa57dc.mp4";